
import { Component, Vue } from 'vue-property-decorator';

interface CalendarData {
  title: string;
  month: string;
  src: string;
  icon: string;
  color: string;
}

@Component
@Component
export default class Calendario extends Vue {
  showModal = false;
  currentIndex = 0;

  calendars: CalendarData[] = [
    {
      title: 'Calendario Enero 2026',
      month: 'Enero',
      src: require('@/assets/img/inicio/enero2026.png'),
      icon: 'fas fa-calendar',
      color: '#56c0e8'
    },
    {
      title: 'Calendario Marzo 2026',
      month: 'Marzo',
      src: require('@/assets/img/inicio/marzo2026.png'),
      icon: 'fas fa-calendar',
      color: '#f27c08'
    }
  ];

  get currentCalendar(): CalendarData {
    return this.calendars[this.currentIndex];
  }

  openModal(index: number): void {
    this.currentIndex = index;
    this.showModal = true;
    // Prevenir scroll del body
    document.body.style.overflow = 'hidden';
  }

  closeModal(): void {
    this.showModal = false;
    // Restaurar scroll del body
    document.body.style.overflow = '';
  }

  selectImage(index: number): void {
    this.currentIndex = index;
  }

  nextImage(): void {
    this.currentIndex = (this.currentIndex + 1) % this.calendars.length;
  }

  previousImage(): void {
    this.currentIndex = (this.currentIndex - 1 + this.calendars.length) % this.calendars.length;
  }

  downloadCalendar(index: number): void {
    const calendar = this.calendars[index];
    const link = document.createElement('a');
    link.href = calendar.src;
    link.download = `calendario-${calendar.month.toLowerCase()}-2026.png`;
    link.click();
  }

  downloadCurrentCalendar(): void {
    this.downloadCalendar(this.currentIndex);
  }

  printCurrentCalendar(): void {
    const printWindow = window.open('', '_blank');
    if (printWindow) {
      printWindow.document.write(`
        <html>
          <head>
            <title>${this.currentCalendar.title}</title>
            <style>
              body { margin: 0; display: flex; justify-content: center; align-items: center; min-height: 100vh; }
              img { max-width: 100%; height: auto; }
            </style>
          </head>
          <body>
            <img src="${this.currentCalendar.src}" alt="${this.currentCalendar.title}">
          </body>
        </html>
      `);
      printWindow.document.close();
      printWindow.focus();
      setTimeout(() => {
        printWindow.print();
        printWindow.close();
      }, 250);
    }
  }

  // Keyboard navigation
  mounted(): void {
    window.addEventListener('keydown', this.handleKeydown);
  }

  beforeDestroy(): void {
    window.removeEventListener('keydown', this.handleKeydown);
    document.body.style.overflow = '';
  }

  handleKeydown(e: KeyboardEvent): void {
    if (!this.showModal) return;

    switch (e.key) {
      case 'Escape':
        this.closeModal();
        break;
      case 'ArrowLeft':
        this.previousImage();
        break;
      case 'ArrowRight':
        this.nextImage();
        break;
    }
  }
}
